import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Suspense } from 'react'
import createSagaMiddleware from 'redux-saga'
// import { render } from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import reducer from './Pages/reducers'
import rootSaga from './containers/sagas'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';
import SiteCatalyst from './sitecatalyst';
import SpinnerComponent from './Common/Spinner/Spinner';
import './utils/i18next'
import { createRoot } from "react-dom/client";

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['customize-order'],
}
 
const persistedReducer = persistReducer(persistConfig, reducer)

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware()
const store = createStore(persistedReducer,
	composeEnhancer(
		applyMiddleware(sagaMiddleware))
)
const persistor = persistStore(store)
sagaMiddleware.run(rootSaga)
SiteCatalyst();
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
		<Suspense fallback={<SpinnerComponent />}>
       		<App />
		</Suspense>
      </PersistGate>
	</Provider>,
	document.getElementById('root')
)
if (module.hot) {
	module.hot.accept(App)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()